var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Hamburger"},[_c('div',{staticClass:"Hamburger__burger-wrapper",class:[{ 'is-active': _vm.$parent.is_open }, { 'is-demo': _vm.is_demo }]},[_c('span',{staticClass:"Hamburger__burger"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }